import "./BookingApiKeyEditView.scss";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import ColorPickerButton from "@/components/Common/ColorPickerButton/ColorPickerButton.vue";
import LogOverview from "@/components/Common/LogOverview/LogOverview.vue";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "BookingApiKeyEditView",
  components: { LogOverview, ColorPickerButton, TreeViewSelection },
  props: ["apiKey", "featureGroups"],
  data: () => ({
    apiKeyPermissions: [
      { value: "edit", title: "Bearbeiten" },
      { value: "view", title: "Sehen" },
      { value: "none", title: "Keine" }
    ]
  }),
  methods: {
    setColorAndCodePreview(key, value) {
      if (!key || !value) return;
      this.apiKey.color[key] = value;
    },
    addFilterItem(value) {
      this.apiKey.availableFilterItems = value;
    },
    addHideFeatureItem(value) {
      this.apiKey.hideFeatures = value;
    },
    getUserName(id) {
      const user = this.allUsers.find(user => user._id.toString() === id);
      if (!user) {
        return "---";
      }
      return `${user.first_name} ${user.last_name}`;
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    allUsers() {
      return this.$store.state.users;
    },
    logUrl() {
      return `${env.booking_api_client_url}log/${this.apiKey._id}`;
    },
    isReadOnly() {
      if (this.isAdmin) {
        return false;
      }
      if (this.apiKey.userPermission === "edit") {
        return false;
      }
      return true;
    },
    filteredFeatureGroups() {
      return this.featureGroups;
    }
  }
};
